/*
 Keyword: react-i18next
 Please search all for know, how to use
 EX:
 import { useTranslation } from 'react-i18next';
 const { t } = useTranslation();
 t(tokens.nav.teachers)
*/
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { en } from './translations/en';
import { vn } from './translations/vn';

const getLanguage = () => {
  return localStorage.getItem('userLanguage') || 'vn';
};
const updateLanguage = async (userLanguage) => {
  await i18n.changeLanguage(userLanguage);
  localStorage.setItem('userLanguage', userLanguage);
};
export { updateLanguage };

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    vn: { translation: vn },
  },
  lng: getLanguage(), // Default language
  fallbackLng: 'vn', // Fallback language if the translation key is not found in the current language
  interpolation: {
    escapeValue: false, // React already safely escapes embedded values
  },
});

export default i18n;
